import React from "react";
import { useNavigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const MisUserDetails =
    sessionStorage.getItem("MisUserDetails") ||
    localStorage.getItem("MisUserDetails");
  if (!MisUserDetails) {
    navigate("/");
    return null;
  }
  return children;
};

export default ProtectedRoute;
